import { render } from "./Listar_comprasViews.vue?vue&type=template&id=135ced22&scoped=true"
import script from "./Listar_comprasViews.vue?vue&type=script&lang=js"
export * from "./Listar_comprasViews.vue?vue&type=script&lang=js"

import "./Listar_comprasViews.vue?vue&type=style&index=0&id=135ced22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135ced22"]])

export default __exports__